import { Button, Dialog } from '@mui/material'
import React from 'react'
import { toast } from 'react-toastify'
import { BlankPageLayout } from './BlankPageLayout'

interface ConfimationModalProps {
  openState: [boolean, SetState<boolean>]
  warningText?: React.ReactNode // Normally just a string
  onConfirm: () => void
  confirmButtonText?: React.ReactNode // Normally just a string
  children?: React.ReactNode
  confirmButtonType?: 'delete' | 'other'
}
export const ConfirmationModal = ({
  openState,
  warningText,
  onConfirm,
  confirmButtonText,
  children,
  confirmButtonType = 'other',
}: ConfimationModalProps) => {
  const [isOpen, setIsOpen] = openState

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <div>
        <BlankPageLayout title="Are you sure?" subtitle={warningText}>
          {children}
          <div className="w-full flex justify-between pt-8">
            <Button onClick={() => setIsOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              color={confirmButtonType === 'delete' ? 'error' : 'inherit'}
              className={confirmButtonType === 'delete' ? undefined : 'bg-red-800'}
              onClick={() => {
                onConfirm()
                toast.warn('This may take a moment to reflect in the U.I.')
                setIsOpen(false)
              }}
            >
              {confirmButtonText || 'Confirm'}
            </Button>
          </div>
        </BlankPageLayout>
      </div>
    </Dialog>
  )
}
